import { Aperture } from "lucide-react";

const EMAIL = "bdofficial703@gmail.com";
const PHONE_RAW = "+919920370131";

export default function Footer() {
  return (
    <footer
      data-testid="footer"
      className="border-t border-white/10 bg-[#0a0a0b]"
    >
      <div className="mx-auto flex max-w-[1400px] flex-col gap-8 px-6 py-12 md:flex-row md:items-center md:justify-between md:px-16">
        <div className="flex items-center gap-3">
          <Aperture className="h-5 w-5 text-[#CBFF3A]" strokeWidth={1.5} />
          <div>
            <div className="font-display text-lg font-600 text-[#ECEAE3]">
              Biswajit Dey
            </div>
            <div className="font-hud text-[10px] uppercase tracking-[0.2em] text-white/40">
              Creative Marketer / Video Producer
            </div>
          </div>
        </div>

        <div className="flex flex-wrap items-center gap-6 font-hud text-[11px] uppercase tracking-[0.2em] text-white/55">
          <a href={`mailto:${EMAIL}`} className="hover:text-[#CBFF3A]">
            {EMAIL}
          </a>
          <a href={`tel:${PHONE_RAW}`} className="hover:text-[#CBFF3A]">
            +91 99203 70131
          </a>
        </div>
      </div>

      <div className="border-t border-white/5 py-5">
        <p className="text-center font-hud text-[10px] uppercase tracking-[0.25em] text-white/30">
          © {new Date().getFullYear()} Biswajit Dey — All frames reserved
        </p>
      </div>
    </footer>
  );
}
